export const isNonNullable = <T>(value: T): value is NonNullable<T> => {
  return value != null; // Note the use of != instead of !== to catch both null and undefined
};

export const isTruthy = <T>(value: T): value is NonNullable<T> => {
  return !!value;
};
